import React from "react";
import './DesktopContainer.css';
import MapDisplay from "../components/MapDisplay";
import MapLegend from "../components/MapLegend";
import MapExplanation from "../components/MapExplanation";
import {IMapContainerProps} from "../utils/IMapContainerProps";

/**
 * Component managing the display of the map on desktop.
 * @author Alizée Grand
 * @version 1.2
 * @creation 26/04/2021
 * @last_update 05/01/2022
 **/
class DesktopContainer extends React.Component<{
    /**
     * Props for the operation of the map.
     */
    mapContainerProps: IMapContainerProps
}> {

    render() {

        return (

            <div id="mapDesktopContainer">
                <div id="grid1">
                    <MapDisplay
                        gpsCoordinates={this.props.mapContainerProps.displayedOnMap.gpsCoordinates}
                        markers={this.props.mapContainerProps.displayedOnMap.markers}
                    />
                </div>
                <div id="grid2">
                    <MapLegend onFilterClick={this.props.mapContainerProps.displayCorrectFilter}/>
                </div>
                <div id="grid3">
                    <MapExplanation />
                </div>
            </div>

        );

    };

}

export default DesktopContainer;
